import {
  ForgotPasswordUseCase,
  LoginUseCase,
  LoginWithTokensUseCase,
  LogoutUseCase,
  ResetPasswordUseCase,
  SwitchOrganizationUseCase,
  ValidateAuthStatusUseCase,
} from "@/application/use-cases";
import { getOrganizationRepository } from "./repositories";
import {
  getAuthService,
  getLogger,
  getMonitoring,
  getOrgStorageService,
  getTokenService,
  getUserStorageService,
} from "./services";

let loginUseCaseInstance: LoginUseCase;
let logoutUseCaseInstance: LogoutUseCase;
let validateAuthUseCaseInstance: ValidateAuthStatusUseCase;
let loginWithTokensUseCaseInstance: LoginWithTokensUseCase;
let forgotPasswordUseCaseInstance: ForgotPasswordUseCase;
let resetPasswordUseCaseInstance: ResetPasswordUseCase;
let switchOrgUseCaseInstance: SwitchOrganizationUseCase;

export function getLoginUseCase(): LoginUseCase {
  if (!loginUseCaseInstance) {
    loginUseCaseInstance = new LoginUseCase(
      getAuthService(),
      getTokenService(),
      getUserStorageService(),
      getMonitoring(),
    );
  }
  return loginUseCaseInstance;
}

export function getLogoutUseCase(): LogoutUseCase {
  if (!logoutUseCaseInstance) {
    logoutUseCaseInstance = new LogoutUseCase(
      getAuthService(),
      getTokenService(),
      getUserStorageService(),
      getLogger(),
      getMonitoring(),
    );
  }
  return logoutUseCaseInstance;
}

export function getValidateAuthUseCase(): ValidateAuthStatusUseCase {
  if (!validateAuthUseCaseInstance) {
    validateAuthUseCaseInstance = new ValidateAuthStatusUseCase(
      getAuthService(),
      getTokenService(),
      getUserStorageService(),
      getLogger(),
      getMonitoring(),
    );
  }
  return validateAuthUseCaseInstance;
}

export function getLoginWithTokensUseCase(): LoginWithTokensUseCase {
  if (!loginWithTokensUseCaseInstance) {
    loginWithTokensUseCaseInstance = new LoginWithTokensUseCase(
      getTokenService(),
      getUserStorageService(),
      getMonitoring(),
    );
  }
  return loginWithTokensUseCaseInstance;
}

export function getForgotPasswordUseCase(): ForgotPasswordUseCase {
  if (!forgotPasswordUseCaseInstance) {
    forgotPasswordUseCaseInstance = new ForgotPasswordUseCase(getAuthService());
  }
  return forgotPasswordUseCaseInstance;
}

export function getResetPasswordUseCase(): ResetPasswordUseCase {
  if (!resetPasswordUseCaseInstance) {
    resetPasswordUseCaseInstance = new ResetPasswordUseCase(getAuthService());
  }
  return resetPasswordUseCaseInstance;
}

export function getSwitchOrganizationUseCase(): SwitchOrganizationUseCase {
  if (!switchOrgUseCaseInstance) {
    switchOrgUseCaseInstance = new SwitchOrganizationUseCase(
      getOrganizationRepository(),
      getTokenService(),
      getOrgStorageService(),
    );
  }
  return switchOrgUseCaseInstance;
}
